import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { authdApiRequest } from '../utils/api';
import { useNavigate } from 'react-router-dom';

function Organizations() {
  const [organizations, setOrganizations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Organizations - DevWing';

    const fetchOrganizations = async () => {
      try {
        const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/organizations`);
        const data = await response.json();
        setOrganizations(data);
      } catch (error) {
        console.error('Error fetching organizations:', error);
      }
    };

    fetchOrganizations();
  }, []);

  return (
    <Layout>
      <h1 className="text-2xl mb-8 font-bold">Organizations</h1>
      <button
        onClick={() => navigate('/organizations/create')}
        className="mb-4 py-2 px-4 rounded-md bg-sky-500 text-white"
      >
        Add New Organization
      </button>
      <table className="min-w-full">
        <thead>
          <tr>
            <th className="text-left py-2 border-b-2 border-zinc-700">Name</th>
            <th className="py-2 border-b-2 border-zinc-700"></th>
          </tr>
        </thead>
        <tbody>
          {organizations.map((team) => (
            <tr key={team.id}>
              <td className="border-b border-zinc-700 py-2">{team.name}</td>
              <td className="border-b border-zinc-700 py-2 text-right">
                <button
                  onClick={() => navigate(`/organizations/edit/${team.id}`)}
                  className="bg-sky-500 text-white py-1 px-2 rounded-md text-sm"
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Layout>
  );
}

export default Organizations; 